import apiClient from '../../core/apiClient';
import { 
  EnterpriseDashboardResponse, 
  WalletResponse, 
  UsageResponse, 
  MarginMetricsResponse,
  RiskHeatmapResponse
} from '../../types/api';

export const strategyService = {
  getEnterpriseDashboard: async () => {
    const response = await apiClient.get<EnterpriseDashboardResponse>('/api/enterprise/dashboard');
    return response.data;
  },
  getWalletBalance: async () => {
    const response = await apiClient.get<WalletResponse>('/api/wallet/balance');
    return response.data;
  },
  getTokenUsage: async () => {
    const response = await apiClient.get<UsageResponse>('/api/usage/history');
    return response.data;
  },
  getBudgetMetrics: async () => {
    const response = await apiClient.get<any>('/api/budget/metrics');
    return response.data;
  },
  getMarginHealth: async () => {
    const response = await apiClient.get<MarginMetricsResponse>('/api/margin/metrics');
    return response.data;
  },
  getPredictiveHealth: async () => {
    const response = await apiClient.get<any>('/api/predictive/health');
    return response.data;
  },
  getTeamUsage: async () => {
    const response = await apiClient.get<EnterpriseDashboardResponse['teamUsage']>('/api/enterprise/team-usage');
    return response.data;
  },
  getUserDashboard: async () => {
    const response = await apiClient.get<any>('/api/user/dashboard');
    return response.data;
  }
};
